<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '创建新项目']"></breadcrumb>
    <div class="container">
      <el-form ref="form" :rules="rules" :model="form" label-position="top" class="main_form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
<!--              <el-input v-model="form.customerName" placeholder="请输入客户名称" />-->
              <el-autocomplete
                class="inline-input"
                v-model="form.customerName"
                :fetch-suggestions="querySearch"
                placeholder="请输入客户名称"
                style="width: 100%"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" placeholder="请输入项目名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="所在省" prop="province">
              <el-select
                v-model="form.province"
                style="width: 181px"
                placeholder="请选择省区"
                @change="handleProvinceChange"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.province"
                  :label="item.province"
                  :value="item.province"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所在市" class="city-con" prop="city">
              <el-select v-model="form.city" placeholder="请选择市区">
                <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商机号/报价号">
              <el-input v-model="form.quote" placeholder="请输入商机号/报价号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input type="textarea" :rows="3" placeholder="请输入备注信息" v-model="form.remark" style="font-size: 14px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col
            :span="24"
            :style="{
            textAlign: 'right',
            borderTop: '1px solid #d9d9d9',
            paddingTop: '16px',
            marginTop: '6px'
          }"
          >
            <el-button @click="getto" style="height: 40px">取消</el-button>

            <el-button type="danger" style="height: 40px" @click="submitForm">
              <template v-if="isEdit">立即创建</template>
              <template v-else>保存</template>
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/pc/Breadcrumb";
import { mapMutations } from "vuex";
import {getcustomList} from "@/api/customManage";
export default {
  name: "Contion",
  components: {
    Breadcrumb,
  },
  beforeCreate() {
    document.body.setAttribute("style", "background:#F4F4F5;");
  },
  computed: {
    cityList() {
      let result = [];
      if (this.form.province) {
        const cityObj = this.provinceList.find(item => item.province == this.form.province);
        if (cityObj) {
          result = cityObj.cities.map(item => {
            return { value: item, lable: item };
          });
        }
      }
      return result;
    },
  },
  data() {
    return {
      isEdit: true,
      taskId: null,
      form: {
        customerName: "", //客户名称
        projectName: "", //项目名称
        province: "", //省份
        city: "", //城市
        quote: "", //报价号
        userId: "gen", //用户id
        coverUrl: "", //封面图片
        remark: "", //备注
        taskId: "",
        projectId: "",
      },
      rules: {
        customerName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
        city: [
          { required: true, message: "请选择城市", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
      },
      provinceList: [],
      customList: []
    };
  },
  methods: {
    ...mapMutations(["changeMenuStatus"]),
    // 客户名称
    getTableList() {
      const data = {
        pageNum: 1,
        pageSize: 1000000,
        customerName: '',
        province: '',
        city: ''
      }
      getcustomList(data).then(res => {
        res.data.records.forEach( item => {
          item.value = item.customerName
        })
        this.customList = res.data.records
      })
    },
    querySearch(queryString, cb) {
      var restaurants = this.customList;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 上面是弹出搜索框
    getBusinessInfo(id) {
      this.$request.getBusinessInfo(id).then(res => {
        if (res.code == 200) {
          this.form = res.data;
        }
      });
    },
    goNewProject() {
      const projectId = this.$route.query.projectId;
      if (projectId) {
        this.$request.getCreateProject(projectId).then(res => {
          this.form = res.data;
          this.form.taskId = this.$route.query.taskId;
          this.form.projectId = this.$route.query.projectId;
        });
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //   alert('submit!')
          if (!this.isEdit) {
            this.saveEditData();
          } else {
            this.saveData();
          }
        } else {
          return false;
        }
      });
    },
    saveEditData() {
      this.$request.editBusiness(this.form).then(res => {
        if (res.code == 200) {
          this.$router.push({
            path: '/manage/doclist/',
            query: {
              id: this.form.id
            }
          })
          //   this.$message.success('创建成功.')
        } else {
          this.$message.error("修改失败:" + res.msg);
        }
      });
    },
    saveData() {
      if (this.taskId) {
        console.log(123);
        this.$request.createProject(this.taskId, this.form).then(res => {
          if (res.code == 200) {
            //   this.$message.success('创建成功.')
            console.log(res, "点击创建的项目");
            this.$router.push({
              path: '/manage/doclist',
              query: {
                id: res.data
              }
            })
          } else {
            this.$message.error("创建失败:" + res.msg);
          }
        });
      } else {
        console.log(456);
        this.$request.createBusiness(this.form).then(res => {
          if (res.code == 200) {
            this.$router.push({
              path: '/manage/doclist',
              query: {
                id: res.data.businessOpportunityId
              }
            })
            //   this.$message.success('创建成功.')
          } else {
            this.$message.error("创建失败:" + res.msg);
          }
        });
      }
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    handleProvinceChange(e) {
      console.log(e);
      this.form.city = undefined;
    },
    getCityList() {
      this.$request.getCityList().then(res => {
        console.log(res, "城市");
        if (res.code == 200) {
          this.provinceList = res.data;
        }
      });
    },
    //点击取消返回商机首页
    getto() {
      this.$router.push("/manage");
    },
    gotask() {
      this.$router.push("/manage/task");
    },
  },
  mounted() {
    const businessId = this.$route.params.id;
    if (businessId) {
      this.form.id = businessId;
      this.getBusinessInfo(businessId);
      this.isEdit = false
    }

    console.log(this.$route.params, "this.$route.params");

    const taskId = this.$route.params.tid;
    if (taskId && businessId) {
      this.taskId = taskId;
      this.isEdit = true;
    }

    this.changeMenuStatus({ value: 1 });

    this.getCityList();
    this.goNewProject();
    this.getTableList()
  },
};
</script>

<style lang="less" scoped>
.main_form {
  padding: 0 136px;

  .city-con {
    ::v-deep .el-form-item__label {
      visibility: hidden !important;
      color: #e60028 !important;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 30px;
  }

  ::v-deep .el-form-item__label {
    line-height: 14px;
    padding-bottom: 15px;
    font-weight: bold;
  }
}
</style>
